import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// ═══════════════════════════════════════════════════════════════════
// NOTA: Funções de formatação de data foram movidas para src/utils/timezone.ts
// Use: import { formatDateBR, formatDateTimeBR, formatDateLocal, etc } from '@/utils/timezone';
// ═══════════════════════════════════════════════════════════════════

// Re-export para manter compatibilidade com imports existentes
export { 
  parseDateLocal, 
  formatDateLocal 
} from '@/utils/timezone';
